import React from 'react';
import { StyledCarouselHome } from './StyledCarouselHome';
import SwiperCore, { Navigation } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import { useHistory } from 'react-router-dom'
import {
  setLoader,
} from "../../redux/loader/loader.actions";
import { useDispatch } from "react-redux";

SwiperCore.use([Navigation]);


const CarouselHome = ({  }) => {
  let history = useHistory();
  const dispatch = useDispatch();
  const handleCLick = (slug) => {
    if(history.location.pathname !== slug){
      
      dispatch(setLoader(true))
      setTimeout(() =>{ 
        document.body.scrollTop = 0;
        history.push(slug)
      }, 500);
    }
  }
  return (
    <React.Fragment>
      {
       
          <StyledCarouselHome>
            <div className="paragraph--col-wrap">
              <div className="paragraph--col-big">
                <h5 className="big--title">
                Discover the products that will add another dimension to the shopping experience
                </h5>
              </div>
              <div className="paragraph--col-small">
                <div className="cta--primary primary-green cursor-cta" onClick={() => handleCLick('/products/index')}>
                  <p className="preset-10 cursor-cta">View all</p>
                  <img className="next cursor-cta" src={require("../../assets/cta-arrow-next-green.svg")} />
                </div>
              </div>
            </div>
            <Swiper 
              
              spaceBetween={0}
              className="carousel-home--slider"
              navigation
              onReachEnd={(swiper) => swiper.snapGrid = [...swiper.slidesGrid]}
              breakpoints={{
                320: {
                  
                  slidesPerView: 2,
                },
                1024: {
                    
                    slidesPerView: 3,
                  },
              }}
              >
                <SwiperSlide>
                  <div className="text--slide">
                    <h6 className="big--title">3D Commerce</h6>
                    <p className="preset-11 paragraph--slide">Our solution to help you transform your e-commerce site into an engaging 3D experience.</p>
                    <div className="cta--primary primary-green cursor-cta" onClick={() => handleCLick('/products/3d-commerce')}>
                      <p className="preset-10 primary-green cursor-cta">Discover</p>
                      <img className="next  cursor-cta" src={require("../../assets/cta-arrow-next-green.svg")} />
                    </div>
                  </div>
                  <div className="img--slide">
                    <img src={require('../../assets/carousel-prod-home/3d-commerce.jpg')} />
                  </div>
                  
                </SwiperSlide>
                <SwiperSlide>
                  <div className="text--slide">
                    <h6 className="big--title">Retail Store Virtualization</h6>
                    <p className="preset-11 paragraph--slide">Our solution to help you get the most out of your retail store by uncovering all the relevant, effective insights and data to perfect the shopping experience.</p>
                    <div className="cta--primary primary-green cursor-cta" onClick={() => handleCLick('/products/retail-store-virtualization')}>
                      <p className="preset-10 primary-green  cursor-cta">Discover</p>
                      <img className="next cursor-cta" src={require("../../assets/cta-arrow-next-green.svg")} />
                    </div>
                  </div>
                  <div className="img--slide">
                    <img src={require('../../assets/carousel-prod-home/retail_store_840x520.jpg')} />
                  </div>
                  
                </SwiperSlide>
                <SwiperSlide>
                  <div className="text--slide">
                    <h6 className="big--title">Virtual Showroom</h6>
                    <p className="preset-11 paragraph--slide">Our solution to help you construct your ideal retail space, event, or experience in VR, giving your content the perfect context.</p>
                    <div className="cta--primary primary-green cursor-cta" onClick={() => handleCLick('/products/virtual-showroom')}>
                      <p className="preset-10 primary-green  cursor-cta">Discover</p>
                      <img className="next cursor-cta" src={require("../../assets/cta-arrow-next-green.svg")} />
                    </div>
                  </div>
                  <div className="img--slide">
                    <img src={require('../../assets/carousel-prod-home/showroom_armani_840x520.jpg')}  />
                  </div>
                  
                </SwiperSlide>
                <SwiperSlide>
                  <div className="text--slide">
                    <h6 className="big--title">Store In-Store</h6>
                    <p className="preset-11 paragraph--slide">Our solution to help you make the most of your retail space, turning your full catalog into an immersive experience.</p>
                    <div className="cta--primary primary-green cursor-cta" onClick={() => handleCLick('/products/store-in-store')}>
                      <p className="preset-10 primary-green cursor-cta">Discover</p>
                      <img className="next cursor-cta" src={require("../../assets/cta-arrow-next-green.svg")} />
                    </div>
                  </div>
                  <div className="img--slide">
                    <img src={require('../../assets/carousel-prod-home/store-in-store_850x520.jpg')} />
                  </div>
                  
                </SwiperSlide>
                <SwiperSlide>
                  <div className="text--slide">
                    <h6 className="big--title">V-Commerce</h6>
                    <p className="preset-11 paragraph--slide">Our solution to help you reinvent the shopping experience, from product discovery to drop-shipping, through the Full Reality.</p>
                    <div className="cta--primary primary-green cursor-cta" onClick={() => handleCLick('/products/v-commerce')}>
                      <p className="preset-10 primary-green cursor-cta">Discover</p>
                      <img className="next cursor-cta" src={require("../../assets/cta-arrow-next-green.svg")} />
                    </div>
                  </div>
                  <div className="img--slide">
                    <img src={require('../../assets/carousel-prod-home/v_commerce_v2_840x520.jpg')} />
                  </div>
                  
                </SwiperSlide>
              
            </Swiper>
            
          </StyledCarouselHome>
          
      }
    </React.Fragment>
  );
};

export default CarouselHome;
